// IMPORTS E CONSTANTES MANTIDAS DO SEU ARQUIVO ORIGINAL...
import React, { useState, useEffect } from "react";
import { Container, Row } from "reactstrap";
import { useNavigate } from 'react-router-dom';
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { Modal, Button, Card, Alert, Typography, Badge, Input, Space } from 'antd';
import { CreditCardOutlined, DollarCircleOutlined, TagsOutlined, CloseOutlined } from '@ant-design/icons';
import './assets/css/Plan.css';
import ApiService from "../util/ApiService";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Swal from "sweetalert2";
import HistoryTransaction from "./HistoryTransaction";
import AuthService from "../login/AuthService";
import LoadingScreen from "../util/LoadingScreen";

const { Title, Text } = Typography;

const Plan = () => {
    document.title = "Planos | Plantão Rápido";
    const history = useNavigate();
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [codeCupom, setCodeCupom] = useState('');
    const [loadingCurrentPlan, setLoadingCurrentPlan] = useState(true);
    const [loadingAvailablePlans, setLoadingAvailablePlans] = useState(true);
    const [loadingPage, setloadingPage] = useState(false);
    const [currentPlan, setCurrentPlan] = useState(null);
    const [availablePlans, setAvailablePlans] = useState([]);

    const fetchAvailablePlans = async () => {
        try {
            const response = await ApiService.send("get", process.env.REACT_APP_URL_API + "payment/summary-plan-list", { users_type_id: 1 }, true);
            const { data } = ApiService.handleApiResponse(response);
            setAvailablePlans(data || []);
            setLoadingAvailablePlans(false);
        } catch (error) {
            ApiService.handleApiError(error);
        }
    };

    const fetchCancel = async () => {
        try {
            setloadingPage(true);
            const response = await ApiService.send("post", process.env.REACT_APP_URL_API + "payment/cancel", { plan_id: currentPlan.id }, true);
            const { data } = ApiService.handleApiResponse(response);
            setloadingPage(false);
            Swal.fire({ icon: 'success', title: 'Cancelamento bem-sucedido!', text: data.message || 'Seu plano foi cancelado com sucesso.' });
            fetchCurrentPlan();
        } catch (error) {
            setloadingPage(false);
            ApiService.handleApiError(error);
        }
    };

    const fetchCurrentPlan = async () => {
        try {
            setLoadingCurrentPlan(true);
            const response = await ApiService.send("post", process.env.REACT_APP_URL_API + "payment/currentPlan", {}, true);
            const { data } = ApiService.handleApiResponse(response);
            setCurrentPlan({
                id: data.id,
                plan_name: data.name,
                value: `R$ ${data.value}`,
                due_date: "Ilimitado",
                limitDuty: data?.user_used?.limit_duty_text,
            });
            setLoadingCurrentPlan(false);
            AuthService.setPlan(data.id);
        } catch (error) {
            ApiService.handleApiError(error);
        }
    };

    const handleCupomChange = async () => {
        try {
            setloadingPage(true);
            const response = await ApiService.send("post", process.env.REACT_APP_URL_API + "payment/activate-coupon", { code: codeCupom }, true);
            Swal.fire({
                icon: 'success',
                title: 'Cupom!',
                text: response.data || 'Seu plano foi atualizado com sucesso.',
            }).then(() => fetchCurrentPlan());
        } catch (error) {
            setloadingPage(false);
            ApiService.handleApiError(error);
        }
    };

    const handleCupomCodeChange = (e) => setCodeCupom(e.target.value);

    useEffect(() => {
        fetchAvailablePlans();
        fetchCurrentPlan();
    }, []);

    const handlePlanSelect = (plan) => {
        setSelectedPlan(plan);
        setShowModal(true);
    };

    const handleSubmitModal = async () => {
        if (currentPlan?.id === selectedPlan?.id) {
            Swal.fire({ icon: 'error', title: 'Oops...', text: 'Você já está no plano selecionado!' });
            setShowModal(false);
        } else {
            if (selectedPlan.value > 0) {
                history('/admin/invoice', { state: { plan: selectedPlan } });
            } else {
                setLoading(true);
                try {
                    const response = await ApiService.send("post", process.env.REACT_APP_URL_API + "payment/edit", { plan_id: selectedPlan.id }, true);
                    setLoading(false);
                    Swal.fire({ icon: 'success', title: 'Sucesso!', text: `Você mudou para o plano ${selectedPlan.name}!` });
                    fetchCurrentPlan();
                    setShowModal(false);
                } catch (error) {
                    ApiService.handleApiError(error);
                }
            }
        }
    };

    return (
        <div className="page-content">
            <Container fluid>
                <BreadCrumb title="Plano" pageTitle="Financeiro" />
                <Row>
                    {loadingPage && <LoadingScreen />}
                    <div className="row">
                        <div className="col-12 col-md-4">
                            <Card title={<><TagsOutlined /> Tem um cupom?</>} style={{ marginBottom: 20 }}>
                                <Space.Compact style={{ width: '100%' }}>
                                    <Input value={codeCupom} placeholder="Digite o código" onChange={handleCupomCodeChange} />
                                    <Button type="primary" onClick={handleCupomChange}>Ativar</Button>
                                </Space.Compact>
                            </Card>
                            <Card title={<><CreditCardOutlined /> Meu Plano Atual</>} style={{ minHeight: 350 }}>
                                {loadingCurrentPlan ? (
                                    <Skeleton count={4} />
                                ) : (
                                    <Badge.Ribbon text="Plano Ativo" color="green">
                                        <div>
                                            <Text><strong>Plano:</strong> {currentPlan.plan_name}</Text><br />
                                            <Text><strong>Preço:</strong> {currentPlan.value}</Text><br />
                                            <Text><strong>Expira em:</strong> {currentPlan.due_date}</Text><br />
                                            <Text><strong>Plantões:</strong> {currentPlan.limitDuty}</Text>
                                        </div>
                                    </Badge.Ribbon>
                                )}
                                {currentPlan && currentPlan?.plan_name !== 'FREE' && (
                                    <Button danger type="dashed" block icon={<CloseOutlined />} onClick={() => {
                                        Swal.fire({
                                            title: 'Cancelar plano?',
                                            text: 'Deseja realmente cancelar seu plano?',
                                            icon: 'warning',
                                            showCancelButton: true,
                                            confirmButtonText: 'Sim',
                                            cancelButtonText: 'Não'
                                        }).then(result => result.isConfirmed && fetchCancel());
                                    }} style={{ marginTop: 16 }}>
                                        Cancelar Plano
                                    </Button>
                                )}
                            </Card>
                        </div>
                        <div className="col-12 col-md-8">
                            <Card title={<><DollarCircleOutlined /> Planos Disponíveis</>} style={{ minHeight: 450 }}>
                                <Text>Escolha um plano abaixo:</Text>
                                <div className="row" style={{ marginTop: 10 }}>
                                    {loadingAvailablePlans ? (
                                        <Skeleton height={150} count={2} />
                                    ) : (
                                        availablePlans.map(plan => (
                                            <div className="col-6" key={plan.id} style={{ marginBottom: 20 }}>
                                                <Badge.Ribbon text={plan.name === 'PRO' ? 'Recomendado' : ''} color="blue">
                                                    <Card>
                                                        <Title level={5}>{plan.name}</Title>
                                                        <Text strong>Preço: R$ {plan.value}</Text><br />
                                                        <Text>{plan.description}</Text><br />
                                                        <Button
                                                            type="primary"
                                                            block
                                                            onClick={() => handlePlanSelect(plan)}
                                                            disabled={currentPlan?.id === plan.id}
                                                            style={{ marginTop: 10 }}
                                                        >
                                                            {currentPlan?.id === plan.id ? 'Plano Atual' : 'Selecionar Plano'}
                                                        </Button>
                                                    </Card>
                                                </Badge.Ribbon>
                                            </div>
                                        ))
                                    )}
                                </div>
                            </Card>
                        </div>
                    </div>
                    <HistoryTransaction />
                    <Modal
                        title="Confirmação de Alteração de Plano"
                        open={showModal}
                        onCancel={() => setShowModal(false)}
                        onOk={handleSubmitModal}
                        okText="Confirmar"
                        cancelText="Cancelar"
                        confirmLoading={loading}
                        centered
                    >
                        <Alert
                            message="Alterar Plano"
                            description={`Você está prestes a mudar para o plano ${selectedPlan?.name}. Confirme abaixo.`}
                            type="info"
                            showIcon
                        />
                    </Modal>
                </Row>
            </Container>
        </div>
    );
};

export default Plan;
